// Width tokens for the InfoPane shell. Collapsed is a thin rail (legacy
// was 45 px — mockup is 48; we follow the mockup). Expanded width is
// fixed; drag-resize was rejected by product after the first iteration.
export const INFO_PANE_WIDTHS = {
  collapsed: 48,
  defaultExpanded: 380,
};
